import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

// Plan 1a Welle 1 (welle-1/AUFTEILUNG.md 5.5): Adressen mit Anker wie …/firmendaten#besitz, #sicherheit-der-firma, #begriffe
// und …/mitglieder#einladungen. React Router springt nicht selbst zu einem Anker; sobald der Abschnitt gezeichnet ist (bereit),
// rückt er in den Blick und bekommt den Fokus, damit Tastatur und Bildschirmleser dort weiterlesen.
// Schlusslauf 3: je Navigation ein Sprung. bereit darf danach wieder wechseln (die Seite lädt nach einer Änderung neu, eine
// Liste wird gefiltert), ohne dass der Blick erneut zum Anker springt.
// PF-SL2-verwaltung-3 (Schlusslauf 2, anmeldung-einladung E17 bei 390 px): gesprungen wird ein Bild später. Ein Link auf einen
// Anker derselben Seite (Kachel „Freie Plätze“ › „Einladungen“) ändert nur den Anker; danach setzt die Bereichsseite im selben
// Durchlauf den Fokus auf die Überschrift (BereichsSeite.tsx, B1.9 – ihre Effekte laufen nach denen des Bereichs). Unter 800 px
// klebt der Seitenkopf nicht, focus() rollte die Überschrift zurück in den Blick und den Abschnitt hinaus; am Desktop blieb der
// Blick, nur der Fokus lag danach auf der Überschrift statt auf dem Abschnitt.
export function useAnkerSprung(bereit: boolean) {
  const { hash, key } = useLocation();
  const gesprungen = useRef<string | null>(null);
  useEffect(() => {
    if (!bereit || !hash || gesprungen.current === key) return;
    const bild = requestAnimationFrame(() => {
      const ziel = document.getElementById(decodeURIComponent(hash.slice(1)));
      if (!ziel) return;
      gesprungen.current = key;
      ziel.scrollIntoView({ block: 'start' });
      if (!ziel.hasAttribute('tabindex')) ziel.setAttribute('tabindex', '-1');
      ziel.focus({ preventScroll: true });
    });
    return () => cancelAnimationFrame(bild);
  }, [bereit, hash, key]);
}
